import React, { useEffect, useState } from 'react';
import { ErrorMessage, useFormik } from 'formik';
import * as yup from 'yup';
import {
    Alert,
    Avatar,
    Box,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    LinearProgress,
    MenuItem,
    Paper,
    Select,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { saveToken, saveUser } from '../core/services/authService';
import leadsService from '../core/services/leadsService';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
const validationSchema = yup.object({
    email: yup.string().email('Enter a valid email').required('Email is required'),
    name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    phone: yup.string().required('Phone number is required')
        .matches(/^[\d\+\-\(\) ]+$/, 'Phone number can only contain numbers, +, -, (, and )')
        .min(10, 'Phone number must be at least 10 characters')
        .max(10, 'Phone number cannot be more than 10 characters'),
    // prefered_location: yup.string().required('Select prefered location'),
    image: yup.string().required('Image is required'),
    password: yup
        .string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters long')
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/, {
            excludeEmptyString: true, // Only apply this rule if the password is not empty
            message: 'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character',
        }),
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: 'auto',
    height: '80%',
    overflow: 'auto',
};
const ISAAddUserModal = ({ getISAAgents, getCountData }) => {
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('error');
    const [alertMesage, setAlertMessage] = useState('Something went wrong');
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (showAlert) {
            setTimeout(() => {
                setShowAlert(false);
                setAlertType('error');
            }, 3000);
        }
    }, [showAlert]);
    const formik = useFormik({
        initialValues: {
            email: '',
            name: '',
            last_name: '',
            phone: '',
            // prefered_location: '',
            image: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (showAlert) setShowAlert(false);
            try {
                setLoading(true);
                const res = await leadsService.isaAgentRegisterByAdminApi(values);
                if (res?.data?.success === true) {
                    setShowAlert(true);
                    toast.success(res?.data?.message)
                    setAlertType('success');
                    formik.resetForm();
                    getISAAgents();
                    getCountData();
                    setOpen(false);
                    return;
                }
                if (res?.response.data) {
                    setShowAlert(true);
                    setAlertMessage(res?.response?.data?.message);
                }
            } catch (error) {
                setShowAlert(true);
                // setAlertMessage(error?.response?.data?.message);
                toast.error(error.message)
            } finally {
                setLoading(false);
            }
        },
    });



    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
        <div>
            {/* <Button
                onClick={handleOpen}
                style={{
                    width: '150px',
                    height: '50px',
                    backgroundColor: '#5379BD',
                    color: 'white',
                    borderRadius: '12px',
                    textTransform: 'capitalize',
                }}
            >
                <AddIcon />  Add ICA
            </Button> */}
            <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <IconButton style={{ position: 'absolute', top: '0px', right: '20px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ marginTop: '18px' }}>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <Box position={'relative'}>
                                {showAlert && (
                                    <Alert
                                        sx={{ position: 'absolute', top: '-90px', left: '28%' }}
                                        severity={alertType}
                                        onClose={() => {
                                            setShowAlert(false);
                                        }}
                                    >
                                        {alertMesage}
                                    </Alert>
                                )}

                                <Stack alignItems={'center'}>
                                    <Paper sx={{ p: 2 }}>
                                        <Typography
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            sx={{ fontSize: '32px', fontWeight: '700', mb: 5 }}>New ICA</Typography>
                                        <form style={{ width: '500px' }} onSubmit={formik.handleSubmit}>
                                            <Stack
                                                display={'flex'} justifyContent={'center'} alignItems={'center'}
                                                spacing={2}>
                                                <Stack
                                                    onClick={() => document.getElementById('image').click()}
                                                    sx={{
                                                        '&:hover': {
                                                            cursor: 'pointer',
                                                        },
                                                    }}
                                                    direction={'row'}
                                                    spacing={1}
                                                    alignItems={'center'}
                                                >
                                                    <Avatar
                                                        sx={{
                                                            border: formik.touched.image && formik.errors.image ? '3px solid #d32f2f' : formik.values.image ? '3px solid green' : '',
                                                            width: '60px',
                                                            height: '60px',
                                                            bgcolor: formik.touched.image && formik.errors.image ? '#d32f2f' : 'rgb(25, 118, 210)',
                                                        }}
                                                        alt="A"
                                                        src={formik?.values?.image ? URL.createObjectURL(formik.values.image) : ''}
                                                    >
                                                        <CloudUploadIcon />
                                                    </Avatar>
                                                    <Typography color={'gray'}> {formik.values.image ? 'Change Image' : 'Upload image'} </Typography>
                                                </Stack>
                                                <small style={{ color: '#d32f2f' }}>{formik.touched.image && formik.errors.image}</small>
                                                <input
                                                    style={{ display: 'none' }}
                                                    id="image"
                                                    name="image"
                                                    type="file"
                                                    onChange={(event) => {
                                                        const file = event.currentTarget.files[0];
                                                        const allowedFormats = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

                                                        if (file && allowedFormats.includes(file.type)) {
                                                            formik.setFieldValue('image', file);
                                                        } else {
                                                            formik.setFieldValue('image', null);
                                                            toast.error('Invalid image format. Only jpeg, png, and jpg, formats are allowed.');
                                                        }
                                                    }}
                                                />

                                                <TextField
                                                    fullWidth
                                                    id="name"
                                                    name="name"
                                                    label="First Name"
                                                    value={formik.values.name}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                                    helperText={formik.touched.name && formik.errors.name}
                                                />
                                                <TextField
                                                    fullWidth
                                                    id="last_name"
                                                    name="last_name"
                                                    label="Last name"
                                                    value={formik.values.last_name}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                                    helperText={formik.touched.last_name && formik.errors.last_name}
                                                />
                                                <TextField
                                                    fullWidth
                                                    id="email"
                                                    name="email"
                                                    label="Email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                                    helperText={formik.touched.email && formik.errors.email}
                                                />
                                                <TextField
                                                    fullWidth
                                                    id="phone"
                                                    name="phone"
                                                    label="Phone #"
                                                    value={formik.values.phone}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                                                    helperText={formik.touched.phone && formik.errors.phone}
                                                />
                                                <TextField
                                                    fullWidth
                                                    id="password"
                                                    name="password"
                                                    label="Password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.password && Boolean(formik.errors.password)}
                                                    helperText={formik.touched.password && formik.errors.password}
                                                />

                                                {/* <FormControl
                                    error={formik.touched.prefered_location && Boolean(formik.errors.prefered_location) ? true : false}
                                    sx={{ m: 1, minWidth: 120 }}
                                >
                                    <InputLabel id="prefered_location">Location</InputLabel>
                                    <Select
                                        onBlur={formik.handleBlur}
                                        labelId="prefered_location"
                                        id="prefered_location"
                                        name="prefered_location"
                                        label="Location"
                                        placeholder="Select your prefered location"
                                        value={formik.prefered_location}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value={'palm_springs'}>Palm Springs</MenuItem>
                                        <MenuItem value={'los_angeles'}>Los Angeles</MenuItem>
                                        <MenuItem value={'sandiego'}>San Diego</MenuItem>
                                        <MenuItem value={'LA North'}>LA North</MenuItem>
                                        <MenuItem value={'LA South'}>LA South</MenuItem>
                                        <MenuItem value={'Orange County'}>Orange County</MenuItem>
                                        <MenuItem value={'Inland Empire North'}>Inland Empire North</MenuItem>
                                        <MenuItem value={'Inland Empire South'}>Inland Empire South</MenuItem>
                                        <MenuItem value={'Desert Cities'}>Desert Cities</MenuItem>
                                        <MenuItem value={'San Diego County North'}>San Diego County North</MenuItem>
                                    </Select>
                                    <FormHelperText>
                                        {formik.touched.prefered_location && formik.errors.prefered_location ? 'Location is Required' : ''}
                                    </FormHelperText>
                                </FormControl> */}
                                                <Box>
                                                    <Button
                                                        disabled={loading}
                                                        sx={{ bgcolor: 'rgb(25, 118, 210)', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', borderRadius: '10px', textTransform: 'capitalize' }}
                                                        variant="contained"
                                                        fullWidth
                                                        type="submit"
                                                    >
                                                        Create ICA
                                                    </Button>
                                                    <LinearProgress sx={{ visibility: loading ? '' : 'hidden' }} />
                                                </Box>
                                            </Stack>
                                        </form>
                                    </Paper>
                                </Stack>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default ISAAddUserModal;

